import React, { useState, useEffect } from "react";
import "../css/Common.css";
import "./Header.css";
import { NavLink, Link, useNavigate } from "react-router-dom";
import logo from "../images/logo.png";
import { getStorage } from "../Utils/common";

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [eligibility, setEligibility] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate(); 

  useEffect(() => {
    const token = getStorage("token");
    const eligibilityStatus = getStorage("eligibility");

    if (token) {
      setIsLoggedIn(true);
    }

    if (eligibilityStatus) {
      setEligibility(eligibilityStatus);
    }

    // Handle scroll effect
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function showNavbar(e) {
    const navbar = document.querySelector(".header_wrapper");
    const navList = document.querySelector(".nav_list");
    
    if (navbar && navList) {
      navList.classList.toggle("v-class");
      navbar.classList.toggle("h-nav");
      navbar.style.zIndex = "9999";
      setIsMenuOpen(!isMenuOpen);
    }
  }

  const closeMobileNav = () => {
    const navbar = document.querySelector(".header_wrapper");
    const navList = document.querySelector(".nav_list");
    
    if (navbar && navList) {
      navList.classList.add("v-class");
      navbar.classList.remove("h-nav");
      setIsMenuOpen(false);
    }
  }

  const handleDashboardClick = () => {
    if (eligibility === 1) {
      navigate("/my-dashboard/eligibility");
    } else {
      navigate("/my-dashboard");
    }
  };

  return (
    <>
      <div className={`header_wrapper ${isScrolled ? 'scrolled' : ''}`}>
        <nav className="nav-container">
          <div className="logo_wrapper">
            <Link to="/" className="logo-link">
              <img src={logo} alt="Udhaar Portal Logo" />
            </Link>
          </div>
          
          <ul className="nav_list">
            <li className="nav-item">
              <NavLink to="/home" onClick={closeMobileNav} className="nav-link">
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about-us" onClick={closeMobileNav} className="nav-link">
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" onClick={closeMobileNav} className="nav-link">
                Contact
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink to="/lending" onClick={closeMobileNav} className="nav-link">
                Lending
              </NavLink>
            </li> */}
            
            <div className="header-buttons">
              <li className="nav-item">
                {isLoggedIn ? (
                  <button
                    className="dashboard-button"
                    onClick={() => { closeMobileNav(); handleDashboardClick(); }}
                  >
                    Dashboard
                  </button>
                ) : (
                  <NavLink to="/apply-now" className="apply-button" onClick={closeMobileNav}>
                    Apply Now
                  </NavLink>
                )}
              </li>

              <li className="nav-item">
                <NavLink to="/repayloan" className="repay-button" onClick={closeMobileNav}>
                  Repay Loan
                </NavLink>
              </li>
            </div>
          </ul>
          
          {/* Mobile Apply Now button */}
          <div className="mobile-apply-button">
            {isLoggedIn ? (
              <button
                className="dashboard-button"
                onClick={() => { closeMobileNav(); handleDashboardClick(); }}
              >
                Dashboard
              </button>
            ) : (
              <NavLink to="/apply-now" className="apply-button" onClick={closeMobileNav}>
                Apply Now
              </NavLink>
            )}
          </div>
          
          <div className={`burger ${isMenuOpen ? 'active' : ''}`} onClick={showNavbar}>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
